const Fetcher = require('od-modules/utils/fetcher');
var trackingUtils = require('../utils/tracking.utils');
var SUGGESTIONS_SPACE = 160;
var options = {
    css: {
        container: `od-passengers-manager-suggestion-container ${Odigeo.AB.isCssVariationMobile ? 'od-prisma-suggestion-container-padding' : ''}`,
        element: 'od-passengers-manager-suggestion-elem odf-text-md odf-clickable od-new-suggestion',
    },
    hasEvents: true,
};
var emailInputsList = {};
var cachedCalls = {};
var keyupEvent;
var blurEvent;
var clickEvent;
var delayId;


var onSuggestionSelected = function(name, e) {
    var field = emailInputsList[name];
    clearTimeout(delayId);
    if (field) {
        field.input.val($(e.target).text()).change().blur();
        unBindClickEvents(field.container);
        trackingUtils.trackEvent('customer_details', name.toLowerCase() + '_autocomplete_clicks');
    }
};

var unBindClickEvents = function($container) {
    $container.find('.mail_suggestion_element').off(Odigeo.Events.mousedown, clickEvent);
    $container.html('');
};

var getDomainFromEmail = function(email) {
    var domain;
    if (Odigeo._.isString(email)) {
        var emailParts = email.split('@');
        if (Odigeo._.size(emailParts) > 1 && Odigeo._.size(emailParts[1]) > 0) {
            domain = emailParts[1];
        }
    }
    return domain;
};

var getDomainFromInput = function($input) {
    return getDomainFromEmail($input instanceof $ ? $input.val() : null);
};
const getUrlParams = (firstLetter) => `${Odigeo.Settings.options.suggestionServiceUrlFormmater('getEmailSuggestions')}?${$.param({
    email: firstLetter,
})}`;
var onEmailValueChanged = function(name, value) {
    var emailParts = value.split('@');
    var user = emailParts[0];
    var domain = emailParts[1];
    var firstLetter = (Odigeo._.first(domain) || '').toLowerCase();
    if (Odigeo._.isArray(cachedCalls[firstLetter])) {
        displaySuggestionsList(name, user, domain, getSuggestionListFilterByDomain(cachedCalls[firstLetter], domain));
    } else {
        Fetcher.get(getUrlParams(firstLetter)).json()
            .then(Odigeo._.bind(getDomainSuggestionSuccess, this, name, value, firstLetter, user, domain));
    }
};

var getDomainSuggestionSuccess = function(name, value, firstLetter, user, domain, suggestionList) {
    var filterList = getSuggestionListFilterByDomain(suggestionList, domain);
    if (Odigeo._.isArray(filterList) && filterList.length) {
        cachedCalls[firstLetter] = suggestionList;
        displaySuggestionsList(name, user, domain, filterList);
    } else {
        closeSuggestionList(name);
    }
};

var getSuggestionListFilterByDomain = function(list, value) {
    value = value.toLowerCase();
    return Odigeo._.filter(list, function(listValue) {
        return Odigeo._.isEmpty(value) || (Odigeo._.startsWith(listValue, value) && listValue !== value);
    });
};

var displaySuggestionsList = function(name, user, domain, filterList) {
    var suggestionElement = emailInputsList[name];
    var $container = $('<ul>', {class: 'mail_suggestion_container ' + suggestionElement.css.container});

    Odigeo._.each(Odigeo._.slice(filterList, 0, 4), function(domain) {
        $container.append($('<li>', {class: 'mail_suggestion_element ' + suggestionElement.css.element}).text(user + '@' + domain));
    }, this);
    clickEvent = Odigeo._.partial(onSuggestionSelected, name, _);
    suggestionElement.container.html($container).removeClass('odf-hidden')
        .find('.mail_suggestion_element').on(Odigeo.Events.mousedown, clickEvent);
};

var isJqueryElem = function($el) {
    return $el instanceof $;
};

var initialize = function(name, $input, $container, options) {
    var isCorrect = !name || isJqueryElem($input) || isJqueryElem($container);
    if (isCorrect) {
        emailInputsList[name] = {
            name: name,
            input: $input,
            container: $container,
            hasChangeValue: false,
            cb: null,
            css: {
                container: '',
                element: '',
            },
        };
        emailInputsList[name] = Odigeo._.merge(emailInputsList[name], options || {});
    }
    return isCorrect;
};

var checkEmailIfContainsAt = function(name, e) {
    checkEmailValueIfContainsAt(name, e.target.value);
};

var checkEmailValueIfContainsAt = function(name, value) {
    if (Odigeo._.includes(value, '@')) {
        onEmailValueChanged(name, value);
    } else {
        closeSuggestionList(name);
    }
};

var closeSuggestionList = function(name) {
    var inputOptions = emailInputsList[name];

    if (inputOptions) {
        inputOptions.container.addClass('odf-hidden');
    }
};

var hasSpaceForSuggestions = function(screenPosition) {
    return ($(window).height() - screenPosition) > SUGGESTIONS_SPACE;
};

module.exports = {
    /**
     * Initialize email suggestion
     * @param {string} name
     * @param {jQuery} $input
     * @param {jQuery} $container
     * @param {jQuery} $focusElement
     * @param {function} onChangeCb
     */
    initEmailSuggestion: function(name, $input, $container, $focusElement, onChangeCb) {
        if (initialize(name, $input, $container, options) && Odigeo._.isObject(options) && options.hasEvents) {
            var onEmailChangeFn = Odigeo._.isFunction(onChangeCb) ? onChangeCb : checkEmailIfContainsAt;
            keyupEvent = Odigeo._.partial(onEmailChangeFn, name, _);
            blurEvent = function() {
                delayId = Odigeo._.delay(Odigeo._.partial(closeSuggestionList, name), 500);
            };
            $input.on(Odigeo.Events.keyup, keyupEvent).on(Odigeo.Events.blur, blurEvent);
            if (Odigeo._.isObject($focusElement) && Odigeo.SessionScope.flow === 'mobile') {
                $input.off(Odigeo.Events.focus, Odigeo._.partial(this.focusFieldEvent, $input, $focusElement))
                    .on(Odigeo.Events.focus, Odigeo._.partial(this.focusFieldEvent, $input, $focusElement));
            }
        }
    },
    focusFieldEvent: function($input, $focusElement) {
        var screenPosition = Odigeo.getRelativeScreenPosition($input);
        var halfScreen = $(window).height() / 2;

        if (screenPosition > halfScreen || !hasSpaceForSuggestions(screenPosition)) {
            Odigeo.Utils.scrollToElement($focusElement, {avoidDefaultOffset: true});
        }
    },
    /**
     * Check Email Value (sometimes already exists an event checking input value change
     * and you don't need you create a new one, if that is the case you can user this function)
     * @param {string} name
     * @param {jQuery} e
     */
    checkEmailValue: function(name, e) {
        if (emailInputsList[name]) {
            checkEmailIfContainsAt(name, e);
        }
    },
    /**
     * Check Email Value by text (sometimes already exists an event checking input value change
     * and you don't need you create a new one, if that is the case you can user this function)
     * @param {string} name
     * @param {string} value
     */
    checkEmailValueByText: function(name, value) {
        if (emailInputsList[name]) {
            checkEmailValueIfContainsAt(name, value);
        }
    },

    getDomainByName: function(name) {
        return emailInputsList[name] ? getDomainFromInput(emailInputsList[name].input) : null;
    },
    /**
     * Close Email Suggestions
     * @param {string} name
     */
    closeSuggestions: function(name) {
        closeSuggestionList(name);
    },
    /**
     * Remove Bind Events
     * @param {string|Array} names
     */
    removeBinds: function(names) {
        Odigeo._.each(Odigeo._.isArray(names) ? names : [names], function(elem) {
            var inputOptions = emailInputsList[elem];
            if (inputOptions) {
                unBindClickEvents(inputOptions.container);
                inputOptions.input.off(Odigeo.Events.keyup, keyupEvent)
                    .off(Odigeo.Events.blur, blurEvent);
                closeSuggestionList(elem);
                inputOptions = null;
            }
        });
    },
};
